import React from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { TransformationSection } from './components/TransformationSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ProductPreview } from './components/ProductPreview';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-primary selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyTopBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <BeforeAfterSection data-id="element-6" />
        <TransformationSection data-id="element-7" />
        <BenefitsGrid data-id="element-8" />
        <ProductBreakdown data-id="element-9" />
        <ProductPreview data-id="element-10" />
        <ValueStack data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <Testimonials data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-charcoal text-white/60 py-8 text-center text-sm" data-id="element-17">
        <div className="max-w-7xl mx-auto px-4" data-id="element-18">
          <p data-id="element-19">
            © {new Date().getFullYear()} Nutrición Canina Fácil. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs text-white/40" data-id="element-20">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}